import { useState } from "react";

const legendaItems = [
  { cor: "bg-primary-500", label: "Saudável / Risco Baixo" },
  { cor: "bg-caution-500", label: "Risco Médio" },
  { cor: "bg-warning-500", label: "Risco Alto" },
  { cor: "bg-danger-500", label: "Risco Crítico" },
  { cor: "bg-blue-400", label: "Área Verde / UC" },
];

const filtrosRapidos = [
  { key: "todas", label: "Todas" },
  { key: "critico", label: "Risco crítico" },
  { key: "poda", label: "Poda recomendada" },
  { key: "supressao", label: "Supressão recomendada" },
  { key: "pendente", label: "Pendentes de revisão" },
];

interface Props {
  municipio: string;
  uf: string;
  areaAbrangencia: string;
}

export default function ProjectMapPreview({ municipio, uf, areaAbrangencia }: Props) {
  const [filtroAtivo, setFiltroAtivo] = useState("todas");

  const mapSrc = `https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15289.230987654321!2d-49.264!3d-16.678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1spt-BR!2sbr!4v1690000000000`;

  return (
    <div className="space-y-4">
      {/* Quick filters */}
      <div className="flex items-center gap-1.5 flex-wrap">
        {filtrosRapidos.map((f) => (
          <button
            key={f.key}
            onClick={() => setFiltroAtivo(f.key)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
              filtroAtivo === f.key
                ? "bg-primary-500 text-white"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* Map */}
      <div className="relative rounded-lg overflow-hidden border border-background-200" style={{ height: "380px" }}>
        <iframe
          src={mapSrc}
          width="100%"
          height="380"
          style={{ border: 0, filter: "saturate(0.85)" }}
          allowFullScreen={false}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={`Mapa do projeto em ${municipio}, ${uf}`}
          className="grayscale-[0.2]"
        ></iframe>

        {/* Legend overlay */}
        <div className="absolute bottom-4 left-4 bg-white rounded-lg p-3 border border-background-200 shadow-sm">
          <p className="text-xs font-semibold text-foreground-700 mb-2 font-heading">Legenda</p>
          <div className="space-y-1.5">
            {legendaItems.map((item) => (
              <div key={item.label} className="flex items-center gap-2">
                <div className={`w-3 h-3 rounded-full ${item.cor}`}></div>
                <span className="text-xs text-foreground-600">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Stats overlay */}
        <div className="absolute top-4 right-4 bg-white rounded-lg px-3 py-2 border border-background-200 shadow-sm">
          <p className="text-xs font-medium text-foreground-700">
            {filtroAtivo === "todas" ? "2.184" : filtroAtivo === "critico" ? "28" : filtroAtivo === "poda" ? "516" : filtroAtivo === "supressao" ? "12" : "196"} árvores
          </p>
          <p className="text-[10px] text-foreground-500">{areaAbrangencia}</p>
        </div>
      </div>
    </div>
  );
}